import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import ukLocale from '@angular/common/locales/uk';
import { APP_INITIALIZER, ApplicationConfig, InjectionToken, LOCALE_ID } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { environment } from '@dp/environments/environment';
import { AuthEffects, AuthInterceptor, AuthService, authReducer } from '@lib/auth';
import { medicalDocumentsReducer } from '@lib/medical-documents';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { provideTranslateModule } from '@lib/core/translate/translate.provider';

import { MD_API_URL } from '@lib/medical-documents/core/tokens/medical-documents.tokens';

import { AUTH_API_URL } from '../../../../packages/core/src/tokens/api.tokens';
import { FIREBASE_API_URL, FIREBASE_CONFIG, FIREBASE_MESSAGING } from '../../../../packages/core/src/tokens/firebase.tokens';
import * as medicalDocumentsEffects from '../../../../packages/medical-documents/src/core/store/medical-documents.effects';
import { routes } from './app.routes';

registerLocaleData(ukLocale);

export function initializeTokens(authService: AuthService) {
  return () => authService.initializeTokens();
}
const API_URL = new InjectionToken<string>('API_URL');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideStore({
      auth: authReducer,
      medicalDocuments: medicalDocumentsReducer,
    }),
    provideEffects([AuthEffects, medicalDocumentsEffects]),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideTranslateModule(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTokens,
      deps: [AuthService],
      multi: true,
    },
    { provide: AUTH_API_URL, useValue: environment.authorizationApiUrl },
    { provide: API_URL, useValue: environment.doctorsPortalApiUrl },
    { provide: MD_API_URL, useValue: environment.protectedApiUrl },
    { provide: FIREBASE_API_URL, useValue: null },
    { provide: FIREBASE_CONFIG, useValue: null },
    { provide: FIREBASE_MESSAGING, useValue: null },
    { provide: LOCALE_ID, useValue: 'uk' },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    provideNativeDateAdapter(),
  ],
};
